import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface ThemeStore {
  isDark: boolean
  toggleTheme: () => void
  setTheme: (isDark: boolean) => void
}

function applyTheme(isDark: boolean) {
  if (isDark) {
    document.documentElement.classList.add('dark')
    document.body.classList.add('dark')
  } else {
    document.documentElement.classList.remove('dark')
    document.body.classList.remove('dark')
  }
}

export const useThemeStore = create<ThemeStore>()(
  persist(
    (set) => ({
      isDark: false,
      toggleTheme: () =>
        set((state) => {
          const next = !state.isDark
          applyTheme(next)
          return { isDark: next }
        }),
      setTheme: (isDark: boolean) => {
        applyTheme(isDark)
        set({ isDark })
      },
    }),
    {
      name: 'theme-store',
      onRehydrateStorage: () => (state) => {
        if (state) applyTheme(state.isDark)
      },
    }
  )
)

export function initializeTheme() {
  try {
    const raw = localStorage.getItem('theme-store')
    if (raw) {
      const parsed = JSON.parse(raw) as { state?: { isDark?: boolean } }
      const stored = parsed?.state?.isDark
      if (typeof stored === 'boolean') {
        useThemeStore.getState().setTheme(stored)
        return
      }
    }
  } catch {
    // fallthrough to default
  }
  useThemeStore.getState().setTheme(useThemeStore.getState().isDark)
}
